import {
    Flex,
    Select,
    Input,
    InputGroup,
    InputLeftAddon,
    SimpleGrid,
  } from "@chakra-ui/react";
  
  import React from "react";

  export default function HeaderCXMData(props) {
    // custom variable
    const {
        inputDateFrom,
        inputDateTo,
        inputBillStatus,
        inputBranch,
        inputCategory,
        setDateFrom,
        setDateTo,
        setInputBillStatus,
        setInputBranch,
        setInputCategory
    } = props;
    
    return (
      <Flex px="25px" justify="space-between" mb="20px" align="center">
      <SimpleGrid
        w="100%"
        mb="20px"
        columns={{ sm: 1, md: 2 }}
        spacing={{ base: "20px", xl: "20px" }}
      >
        <InputGroup>
          <InputLeftAddon children="Date From" />
          <Input
            focusBorderColor="black"
            placeholder="Select Date From"
            borderRadius="16px"
            type="date"
            value={inputDateFrom}
            onChange={(e) => setDateFrom(e.target.value)}
          />
        </InputGroup>
        <InputGroup>
          <InputLeftAddon children="Date To" />
          <Input
            focusBorderColor="black"
            placeholder="Select Date To"
            borderRadius="16px"
            type="date"
            value={inputDateTo}
            onChange={(e) => setDateTo(e.target.value)}
          />
        </InputGroup>
        <InputGroup>
          <InputLeftAddon children="Bill ID" />
          <Input
            focusBorderColor="black"
            placeholder="Input Bill ID"
            borderRadius="16px"
            value={inputBillStatus}
            onChange={(e) => setInputBillStatus(e.target.value)}
          />
        </InputGroup>
        <InputGroup>
          <InputLeftAddon children="Category" />
          <Input
            focusBorderColor="black"
            placeholder="Input Category"
            borderRadius="16px"
            value={inputCategory}
            onChange={(e) => setInputCategory(e.target.value)}
          />
        </InputGroup>
      </SimpleGrid>
    </Flex>
      
    );
  }
  